<!-- 情书贺卡活动页设置 -->
<template>
  <div>
    <activityPageSettings isShowShopName :cusTemplateJSON.sync="cusTemplateJSON" v-model="localConfig" defaultTitleKey="activityTitle" defaultDescKey="activityDescription" defaultTitleColorKey="wordColor" previewKey="imageUrl" :giftList="giftList" :templateId="templateId" @selectTemplate="selectTemplateFn" :isNeedSetBG="false">
      <template #otherSet>
        <el-form-item label="接收情书页模板：" label-position="left">
          <div class="showImageContent" @click="showImage">
            <i class="el-icon-search"></i>
            点击查看大图
          </div>
        </el-form-item>
        <el-form-item label="自定义背景图：" label-position="left">
          <div class="miniAppPic">
            <div class="top">
              <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                :before-upload="(file) => onBeforeUpload(file, '1')" :on-success="onUploadSuccess"
                :disabled="backgroundOpacity">
                <jd-button type="blue" :disabled="backgroundOpacity">自定义上传</jd-button>
              </el-upload>
              <jd-button class="ml-8" type="blueText" :disabled="backgroundOpacity" @click="onPicReset">重置</jd-button>
              <jd-button type="blueText" :disabled="backgroundOpacity" @click="onDownload">下载模板</jd-button>
              <jd-button type="blueText" @click="onShowStandard">查看设计规范</jd-button>
            </div>
            <div class="bottom" v-if="localConfig.selfImage">
              <el-image class="elImg" :src="localConfig.selfImage" fit="contain">
                <div slot="error" class="image-slot">
                  <i class="el-icon-plus"></i>
                </div>
              </el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="自定义接收页背景图：" label-position="left">
          <div class="miniAppPic">
            <div class="top">
              <el-upload class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                :before-upload="(file) => onBeforeUpload(file, '2')" :on-success="onUploadSuccess2"
                :disabled="backgroundOpacity">
                <jd-button type="blue" :disabled="backgroundOpacity">自定义上传</jd-button>
              </el-upload>
              <jd-button class="ml-8" type="blueText" :disabled="backgroundOpacity" @click="onPicReset2">重置</jd-button>
              <jd-button type="blueText" :disabled="backgroundOpacity" @click="onDownload2">下载模板</jd-button>
              <jd-button type="blueText" @click="onShowStandard2">查看设计规范</jd-button>
            </div>
            <div class="bottom" v-if="localConfig.selfReceiveImage">
              <el-image class="elImg" :src="localConfig.selfReceiveImage" fit="contain">
                <div slot="error" class="image-slot">
                  <i class="el-icon-plus"></i>
                </div>
              </el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="情书模板：" label-position="left" required>
          <div class="billetDouxTemplate">
            <div class="bill_top">
              (最多选择5个模板)
            </div>
            <div class="bill_bottom" :class="backgroundOpacity ? 'noEdit' : ''">
              <div v-for="(template, index) in templateList" :key="index" class="template-item"
                :class="{ 'selected': localConfig.selectedTemplates.includes(template) }" @click="toggleTemplate(template)">
                <img :src="template" />
                <div class="selected-overlay" v-if="localConfig.selectedTemplates.includes(template)">
                  <i class="el-icon-check"></i>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </template>
    </activityPageSettings>

    <ImagePreviewDialog :visible.sync="dialogVisible" :image-url="previewImage" :width="imageW" :height="imageH"
      @close="closeDialog" />
  </div>
</template>

<script>
import activityPageSettings from '../../activityPageSettings.vue'
import ImagePreviewDialog from './_components/ImagePreviewDialog.vue';
const qshkRuleImage = 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/qshkRule.png'
const qshkRuleImage2 = 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/active/qshkRule2.png'
export default {
  name: 'ActivityPageForm',
  components: {
    ImagePreviewDialog,
    activityPageSettings
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    backgroundOpacity: {
      type: Boolean,
      default: false
    },
    // 选择的模板
    selectTemplate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    templateJson: {
      type: String,
      default: ''
    },
    templateId: {
      type: String,
      default: ''
    },
    giftList:{
      type: Array,
      default: []
    }
  },
  data() {
    return {
      cusTemplateJSON:"",
      localConfig: this.value,
      uploadSize: false,
      dialogVisible: false, // 控制弹窗显示
      imageW: 800, // 预览图片宽度
      imageH: 600, // 预览图片高度
      previewImage: '', // 预览图片
      templateList: [ // 模板列表
        'https://cdn-image.yucrm.cn//hd/images/13315956_51d047f477ba49ff8dc738970bfd831d.png',
        'https://cdn-image.yucrm.cn//hd/images/13315956_32bbf02e96624ad086e9a99568b51310.png',
      ],
    };
  },
  watch: {
    value: {
      handler(val) {
        this.localConfig = val;
      },
      deep: true
    },
    localConfig: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    },
    selectTemplate: {
      handler(){
        this.onPicReset()
        this.onPicReset2()
      },
      deep: true
    },
  },
  mounted() {
  },
  methods: {
    selectTemplateFn(index,id,items){
      this.$emit("selectTemplateFn",index,id,items)
    },
    // 重置文字颜色
    onTextColorReset() {
      this.localConfig.wordColor = "#1A1A1A";
    },
    // 上传图片前校验
    onBeforeUpload(file, kind) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 750;
        let height = 1740;
        if (kind == '2') {
          height = 1624
        }
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          let valid = width === this.width && height === this.height;
          valid ? resolve() : reject(this);
          _this.uploadSize = valid;
        }
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        return file
      }, () => {
        this.$message.info("图片宽高不符合要求,请重新上传");
        return Promise.reject()
      })

      // 校验尺寸和类型
      const isLt2M = file.size < 1024 * 1024 * 2;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isType = sorts.includes(type)

      if (!isLt2M) {
        this.$message.info("上传图片大小不能超过 2MB");
      }
      if (!isType) {
        this.$message.info("所选文件格式不符，请重新选择");
      }

      return isLt2M && isType && isSize;
    },
    // 上传成功(自定义背景图)
    onUploadSuccess(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (this.uploadSize) {
          this.localConfig.selfImage = res.data;
          this.$forceUpdate();
        }
      }
    },
    // 上传成功(自定义接收页背景图)
    onUploadSuccess2(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (this.uploadSize) {
          this.localConfig.selfReceiveImage = res.data;
          this.$forceUpdate();
        }
      }
    },
    // 重置图片(自定义背景图)
    onPicReset() {
      if (this.selectTemplate && Object.keys(this.selectTemplate).length > 0) {
        this.localConfig.selfImage = this.selectTemplate.url;
      } else {
        this.localConfig.selfImage = JSON.parse(this.templateJson).url;
      }
    },
    // 重置图片(自定义接收页背景图) 
    onPicReset2() {
      if (this.selectTemplate && Object.keys(this.selectTemplate).length > 0) {
        this.localConfig.selfReceiveImage = this.selectTemplate.url3;
      } else {
        this.localConfig.selfReceiveImage = JSON.parse(this.templateJson).url3;
      }
    },
    // 下载模板(自定义背景图)
    onDownload() {
      console.log("--- 下载模板(自定义背景图) ---");
      // 获取图片地址
      let url =
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/loveCard/情书贺卡.psd";
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "情书贺卡规范";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    // 下载模板(自定义接收页背景图)
    onDownload2() {
      console.log("--- 下载模板(自定义接收页背景图) ---");
      // 获取图片地址
      let url =
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/loveCard/情书贺卡-接收页.psd";
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "情书贺卡-接受页规范";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    // 查看设计规范(自定义背景图)
    onShowStandard() {
      this.imageW = 760;
      this.imageH = 524;
      this.previewImage = qshkRuleImage
      this.dialogVisible = true
    },
    // 查看设计规范(自定义接受也背景图)
    onShowStandard2() {
      this.imageW = 760;
      this.imageH = 524;
      this.previewImage = qshkRuleImage2
      this.dialogVisible = true
    },
    // 选中模板
    toggleTemplate(template) {
      const index = this.localConfig.selectedTemplates.indexOf(template);
      if (index > -1) {
        // 取消选中
        this.localConfig.selectedTemplates.splice(index, 1);
      } else {
        // 选中（最多5个）
        if (this.localConfig.selectedTemplates.length < 5) {
          this.localConfig.selectedTemplates.push(template);
        } else {
          this.$message.warning('最多只能选择5个模板');
        }
      }
    },
    // 预览图片
    showImage() {
      if (this.selectTemplate && this.selectTemplate.secondImageUrl) {
        this.previewImage = this.selectTemplate.secondImageUrl;
      } else {
        this.previewImage = JSON.parse(this.templateJson).cPreviewUrl;
      }

      this.dialogVisible = true;
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.buttonGroup {
  display: flex;
  align-items: center;
}

.miniAppPic {
  position: relative;

  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;

    i {
      font-size: 30px;
      color: #909399;
    }
  }

  .top {
    position: relative;
    display: flex;
    left: 0;
  }

  .bottom {
    position: relative;
    top: 15px;
    // left: 125px;
    width: 800px;

    .elImg {
      height: 230px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
  }
}

.billetDouxTemplate {
  display: flex;
  flex-direction: column;
  color: #333;
  width: 800px;

  .bill_bottom {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;

    .template-item {
      position: relative;
      width: 152px;
      border: 2px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.3s;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        border-color: #3159FF;
      }

      &.selected {
        border-color: #3159FF;
        background-color: #f0f9ff;
      }

      img {
        width: 100%;
        // height: 100%;
        object-fit: cover;
      }

      .selected-overlay {
        position: absolute;
        top: 0;
        right: 0;
        width: 20px;
        height: 20px;
        background-color: #3159FF;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
      }
    }

    // 如果使用 checkbox 或 radio
    .template-checkbox,
    .template-radio {
      margin-right: 10px;

      /deep/ .el-checkbox__input,
      /deep/ .el-radio__input {
        display: none; // 隐藏默认的选择框
      }

      /deep/ .el-checkbox__label,
      /deep/ .el-radio__label {
        padding: 0;
      }
    }
  }
}

.showImageContent {
  color: #333;
  width: 120px;
  height: 60px;
  background-color: #F2F2F2;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: transparent;
  }

  &:hover {
    background-color: rgba(0, 0, 0, .7);
    cursor: pointer;

    i {
      color: #fff;
      font-size: 25px;
    }
  }
}


.noEdit {
  cursor: not-allowed;
  pointer-events: none;
}

.ml-8 {
  margin-left: 8px;
}

.ml-30 {
  margin-left: 30px;
}
</style>